import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from 'app/main/pages/administration-area/services/user.service';
import { VideocallService } from 'app/main/pages/common-area/apps/videocall/videocall.service';
import { EventsService } from 'app/main/services/events.service';
import { UtilsService } from 'app/main/services/utils.service';
import { IChatController, IChatParticipant, Localization, Window } from 'ng-chat';
import { Subscription } from 'rxjs';
import { EliminazioneComponent } from '../../alert/eliminazione/eliminazione.component';
import { EmergenciesService } from '../../services/emergencies.service';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';
import { ChatAdapterImplementation } from './chat-adapter-implementation';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {

  eventsSub: Subscription;
  adapter: ChatAdapterImplementation;
  chatDisabled: boolean;
  searchEnabled: boolean;
  showCloseButton: boolean;
  historyEnabled: boolean;
  hideFriendsList: boolean;
  messagePlaceholder: string;
  messageDatePipeFormat: string;
  isCollapsed: boolean;
  isViewportOnMobileEnabled: boolean;
  localization: Localization;
  maximizeWindowOnNewMessage: boolean;
  persistWindowsState: boolean;

  @ViewChild('ngChatInstance')
  protected ngChatInstance: IChatController;

  @Input()
  public chatRoleEnabled: Array<any>;


  fileUrl: any;
  userInfo: any;
  emergencies: {};
  isInEmergency: boolean;
  myUserUuid: any;
  firstMerge: boolean;
  initialized: boolean;
  user: any;

  constructor(
    public dialogMat: MatDialog,
    private snackBarMat: MatSnackBar,
    private loaderService: LoaderService,
    private eventsService: EventsService,
    private localAccountService: LocalAccountService,
    private userService: UserService,
    private chatService: ChatService,
    private domSanitizer: DomSanitizer,
    private emergenciesService: EmergenciesService,
    private videocallService: VideocallService,
    private utilsService: UtilsService
  ) {
    this.persistWindowsState = false;
    this.initialized = false;
    this.chatDisabled = true;
    this.showCloseButton = false;
    this.searchEnabled = false;
    this.historyEnabled = true;
    this.hideFriendsList = true;
    this.isCollapsed = false;
    this.isViewportOnMobileEnabled = true;
    this.maximizeWindowOnNewMessage = false;
    this.messagePlaceholder = 'Scrivi un messaggio';
    this.messageDatePipeFormat = 'dd-MM-yyyy HH:mm:SS';
    this.chatService.setThereIsAdapter(true);
    this.adapter = new ChatAdapterImplementation(
      this.chatService,
      this.userService,
      [
        {
          key: 'utenti',
          name: 'utenti',
          title: 'utenti',
          mergeInList: false,
          windowOptions: {
            buttons: [{
              title: 'video_call',
              showIcon: true,
              icon: 'video_call',
              action: (chattingTo: Window) => {
                console.log(chattingTo);
              },
              enableButton: (participant: IChatParticipant) => {
                if (this.videocallService.isInCall()) {
                  return false;
                }
                return true;
              },
            }],
            windowClass: 'utenti'
          }
        }
        // ,
        // {
        //   key: 'specialisti',
        //   name: 'specialisti',
        //   title: 'specialisti',
        //   mergeInList: true,
        //   windowOptions: {
        //     buttons: [{
        //       title: 'video_call',
        //       showIcon: true,
        //       icon: 'video_call',
        //       action: (chattingTo: Window) => {
        //         console.log(chattingTo);
        //         this.eventsService.publishEvent({
        //           event: 'clickOperator',
        //           userId: chattingTo.participant.id
        //         });
        //         this.ngChatInstance.triggerToggleChatWindowVisibility(chattingTo.participant.id);

        //       },
        //       enableButton: (participant: IChatParticipant) => {
        //         if (participant.status === 0 && !this.videocallService.isInCall()) {
        //           return true;
        //         }
        //         return false;
        //       },
        //     }],
        //     windowClass: 'specialisti'
        //   }
        // }
      ]);
    if (!this.emergencies) {
      this.emergencies = {};
    }
    this.localization = {
      title: 'Chat Video Lezione',
      messagePlaceholder: this.messagePlaceholder,
      searchPlaceholder: 'Ricerca',
      browserNotificationTitle: 'Nuovo messaggio',
      loadMessageHistoryPlaceholder: 'Caricamento',
      statusDescription: {
        online: 'ONLINE',
        busy: 'OCCUPATO',
        away: 'AWAY',
        offline: 'OFFLINE'
      }
    };
  }

  async ngOnInit() {
    await this.listenOnEvents();
    // this.localAccountService.getAccount().then((account) => {
    //   this.myUserUuid = account.userId;
    //   this.adapter.setMyUserId(this.myUserUuid);
    //   setTimeout(() => {
    //     if (this.ngChatInstance) {
    //       this.ngChatInstance.setBeforeParteciantChatClosed(this.beforeChatClosed.bind(this));
    //     }
    //   }, 500);
    // });
    // setTimeout(() => {
    //   console.log('adding public fetch');
    //   this.ngChatInstance['publicFetch'] = this.publicFetch;
    // }, 200);
  }

  async listenOnEvents() {
    if (!this.eventsSub) {
      this.eventsSub = this.eventsService.listenOnEvents().subscribe(async (data) => {
        if (data && data.event) {
          switch (data.event) {
            // case 'LOGIN':
            //   setTimeout(() => {
            //     this._initializeChat();
            //   }, 500);

            //   break;
            case 'OPENCHAT':
              this.openChat(data, true);
              break;
            case 'INITIALIZE_CHAT':
              this.openChat(data, false);
              break;
            case 'CLOSECHAT':
              this.closeChat(data);
              break;
            case 'NEWCHATMESSAGE':
              this.newMessage(data);
              break;
            case 'closeemergency':
              this.remoteCloseEmergency(data.data);
              break;
            // case 'userslist':
            //   this.mergeOperators(data.data);
            //   break;
            case 'removeEmergency':
              if (this.emergencies &&
                this.emergencies[data.emergency.userId] &&
                this.emergencies[data.emergency.userId].emergencyId === data.emergency.emergencyId) {
                this.isInEmergency = false;
                delete this.emergencies[data.emergency.userId];
                this.ngChatInstance.triggerCloseChatWindow(data.emergency.userId);
              }
              break;
            default:
              break;
          }
        }
      });
    }
  }

  closeChat(data) {
    this.chatDisabled = true;
    this.adapter.setMyUserId(null);
    if (this.user) {
      this.ngChatInstance.triggerCloseChatWindow(this.user.id);
      this.user = null;
    }
  }

  private async _initializeChat() {
    await this.localAccountService.getAccount().then((account) => {
      if (!account || !account.userId) {
        setTimeout(() => {
          this._initializeChat();
        }, 500);
        return;
      }
      if (this.chatRoleEnabled && !this.chatRoleEnabled.includes(account.ruolo)) {
        this.myUserUuid = null;
        this.adapter.setMyUserId(this.myUserUuid);
        this.chatDisabled = true;
        // this.userService.getOperators().subscribe((resp: any) => {
        //   console.log(resp);
        //   if(resp.payload)
        //     this.mergeOperators(resp.payload)
        // });
        this.initialized = false;
      } else {
        this.myUserUuid = account.userId;
        this.adapter.setMyUserId(this.myUserUuid);
        // console.log('chat enabled!!!')
        this.chatDisabled = false;
        // this.userService.getOperators().subscribe((resp: any) => {
        //   console.log(resp);
        //   if(resp.payload)
        //     this.mergeOperators(resp.payload)
        // });
        this.initialized = true;
      }
    });
  }

  // publicFetch() {
  //   console.log(this);
  //   this['fetchFriendsList'](false);
  // }

  mergeOperators(data) {
    // console.log('chat component merge operators')
    this.firstMerge = true;
    if (!this.ngChatInstance) {
      setTimeout(() => {
        this.mergeOperators(data);
      }, 200);
      return;
    }
    this.adapter.mergeList('utenti', data).then(() => {
      // if(this.ngChatInstance['publicFetch'] == undefined || this.ngChatInstance['publicFetch'] == null) {
      //   this.ngChatInstance['publicFetch'] = this.publicFetch;
      // } 
      // this.ngChatInstance['publicFetch']();
      this.adapter.mergeAllList();
      this.ngChatInstance.fetchFriendsList(false);
    });
  }

  openChat(data, triggerOpenChatWindow) {
    console.log('opening user chat');
    this._initializeChat();
    let contactId = 15;
    let emergencyId;
    const user = {
      participant: {
        participantType: 0,
        id: contactId,
        displayName: 'Test test',
        avatarSrc: 'https://thumbnail.myheritageimages.com/502/323/78502323/000/000114_884889c3n33qfe004v5024_C_64x64C.jpg',
        status: 0,
        windowOptions: null
      }
    };
    this.isInEmergency = true;
    user.participant.avatarSrc = '/assets/images/admin-image.jpg';
    if (data) {
      user.participant.id = data.contactId;
      contactId = data.contactId;
      emergencyId = data.emergencyId;
      if (!this.emergencies) {
        this.emergencies = {};
      }
      this.emergencies[contactId] = {
        contactId: contactId,
        emergencyId: emergencyId
      };
      this.loaderService.showLoader();
      this.userService.getUserInfoByUserId(contactId)
        .subscribe((data2: any) => {
          this.userInfo = data2.payload;
          user.participant.displayName = this.userInfo.name + ' ' + this.userInfo.surname;
          // TODO
          // user.participant.avatarSrc = this.userService.retrieveProfileImageUidEndpoint(contactId, false);
          user.participant.windowOptions = {
            // buttons: [{
            //   title: 'test',
            //   showIcon: true,
            //   icon: 'video_call',
            //   action: (chattingTo: Window) => {
            //     console.log(chattingTo);
            //     if (this.emergencies && this.emergencies[chattingTo.participant.id]) {
            //       // tslint:disable-next-line:max-line-length
            // tslint:disable-next-line:max-line-length
            //       // this.videocallEventInteractionService.publishData({event:'toolbarVideocallStart', contactId: this.emergencies[chattingTo.participant.id].contactId, emergencyId: this.emergencies[chattingTo.participant.id].emergencyId})
            //       // tslint:disable-next-line:max-line-length
            // tslint:disable-next-line:max-line-length
            //       // this.eventsService.publishData({event:'toolbarVideocallStart', contactId: this.emergencies[chattingTo.participant.id].contactId, emergencyId: this.emergencies[chattingTo.participant.id].emergencyId})
            //       this.emergenciesService.tryToUpdateEmergency(
            //         this.emergencies[chattingTo.participant.id].emergencyId,
            //         'request',
            //         'VIDEO',
            //         (res) => {
            //           // tslint:disable-next-line:max-line-length
            // tslint:disable-next-line:max-line-length
            //           this.eventsService.publishEvent({ event: 'toolbarVideocallStart', contactId: this.emergencies[chattingTo.participant.id].contactId, emergencyId: this.emergencies[chattingTo.participant.id].emergencyId });
            //           this.ngChatInstance.triggerToggleChatWindowVisibility(this.emergencies[chattingTo.participant.id].contactId);
            //         });
            //     }
            //   },
            //   enableButton: (participant: IChatParticipant) => {
            //     if (this.videocallService.isInCall()) {
            //       return false;
            //     }
            //     return true;
            //   },
            // }],
            windowClass: 'utenti'
          };
          this._openChat(user.participant, triggerOpenChatWindow);
          this.loaderService.hideLoader();
        },
          (error) => {
            this.snackBarMat.open('Errore caricamento profilo', '', {
              duration: 3000,
              panelClass: 'warn',
            });
            this.loaderService.hideLoader();
          });

    } else {
    }


  }

  _getSafeUrl() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.fileUrl);
  }

  _openChat(user, openChatWindow) {
    if (!this.chatDisabled) {
      this.adapter.resetLists('utenti');
      this.adapter.addToList('utenti', user);
      // if (openChatWindow) {
      this.ngChatInstance.triggerOpenChatWindow(user);
      this.user = user;
      // }
      // this.emergenciesService.tryToUpdateEmergency(
      //   this.emergencies[user.id].emergencyId,
      //   'add',
      //   'CHAT',
      //   null
      // );
      // this.chatService.send(user.id, { message: 'COMMAND_OPENCHAT' }, new Date());
    }
  }

  newMessage(data) {
    if (data.message) {
      this.adapter.newMessage(data.message);
    }
  }

  async beforeChatClosed(participant): Promise<boolean> {
    console.log(participant);
    const res = await this._beforeChatClosed(participant);
    return res;
  }

  _beforeChatClosed(participant) {
    return new Promise<boolean>((resolve) => {
      this.newConfirmation(null, (result) => {
        if (result && result.data) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  // New delete dialog
  newConfirmation(data: any, callback: any) {
    const dialog = this.dialogMat.open(EliminazioneComponent, {
      // data: `${data}`,
      data: {
        newWay: true,
        title: 'Conferma Operazione',
        body: 'Sei sicuro?'
      }

    });
    dialog.afterClosed().subscribe((datas) => {
      if (datas && datas['data']) {
        callback(datas);
      } else {
        callback(null);
      }
    });
  }

  onChatToggle(payload) {
    console.log('onChatToggle', payload);
    // if (this.emergencies && this.emergencies[payload.participant.id]) {
    //   if (payload.isCollapsed) {
    //     // this.chatService.sendCommand(
    //     //   'hidechat',
    //     //   {
    //     //     userUuid: payload.participant.id,
    //     //     uuid: payload.participant.id,
    //     //     to: payload.participant.id,
    //     //     toUserId: payload.participant.id,
    //     //     message: 'hidechat',
    //     // });
    //     this.chatService.emit('hideChat', { 'to': payload.participant.id }, 'call');
    //   } else {
    //     // this.chatService.sendCommand(
    //     //   'showchat',
    //     //   {
    //     //     userUuid: payload.participant.id,
    //     //     uuid: payload.participant.id,
    //     //     to: payload.participant.id,
    //     //     toUserId: payload.participant.id,
    //     //     message: 'showchat',
    //     // });
    //     this.chatService.emit('showChat', { 'to': payload.participant.id }, 'call');
    //   }
    // }
  }

  onChatClosed(participant) {
    console.log('onChatClosed', participant);
    // if (this.emergencies && this.emergencies[participant.id]) {
    //   const em = this.emergenciesService.getEmergencyById(this.emergencies[participant.id].emergencyId);
    //   if (em && em.videoEnabled) {
    //     this.chatService.emit('hideChat', { 'to': participant.id }, 'call');
    //     this.emergenciesService.tryToUpdateEmergency(
    //       this.emergencies[participant.id].emergencyId,
    //       'remove',
    //       'CHAT', (e) => {
    //         this.isInEmergency = false;
    //         delete this.emergencies[participant.id];
    //         this.emergenciesService.tryToUpdateEmergency(
    //           this.emergencies[participant.id].emergencyId,
    //           'unrequest',
    //           'CHAT', null);
    //       });
    //   } else {
    //     this.closeEmergency(participant.id);
    //     this.chatService.forceCloseEmergency(participant.id);
    //     this.adapter.removeFromList('utenti', participant.id);
    //   }
    // }
  }

  remoteCloseEmergency(data) {
    const toUserId = data.result.fromUser.uuid;
    if (!this.isInEmergency || !this.emergencies || !this.emergencies[toUserId]) {
      return;
    }
    const emergencyId = this.emergencies[toUserId].emergencyId;
    this.utilsService.newWarningSnackbar('Sessione chiusa dall\'utente remoto.');
    this.emergenciesService.removeClosedEmergencyById(emergencyId, (res) => {
      delete this.emergencies[toUserId];
      this.ngChatInstance.triggerCloseChatWindow(toUserId);
    }, (err) => {
      console.log(err);
    });
    // this.askForNotes(this._formBuilder, this.notificationService, emergencyId)
    //   .then(
    //     (dataNote) => {
    //       this.newSnackbar(`Nota chiusura creata.`, 'success');
    //       console.log('errNote: ', dataNote);

    //     },
    //     (errNote) => {
    //       this.newSnackbar(`Errore creazione nota chiusura.`, 'warn');
    //       console.log('errNote: ', errNote);
    //     }
    //   );

  }

  closeEmergency(toUserId: any) {
    const closed = (result) => {
      if (result && result.data) {
        this.loaderService.showLoader();
        this.emergenciesService.removeEmergencyByUserId(
          toUserId,
          (res) => {
            this.isInEmergency = false;
            delete this.emergencies[toUserId];
          },
          (error) => {
            this.loaderService.hideLoader();
            console.error(error);
            delete this.emergencies[toUserId];
          });
        // return this.notificationService.closeEmergencyByPatientId(toUserId).subscribe((res: any) => {
        //   let emergencyId = null;
        //   if (res['payload'] != undefined && res['payload'] != null)
        //     emergencyId = res['payload'].emergencyId;
        //   this.notificationService.getEmergencyNotfications('OPEN, PROCESSING').subscribe((resp: any) => {
        //     this.notificationService.updateEmergencyNotificationsValue(true);
        //   });
        //   this.isInEmergency = false;
        //   // this.newSnackbar(`Emergenza chiusa.`, 'success');
        //   if (emergencyId == undefined || emergencyId == null) {
        //     emergencyId = this.emergencies[toUserId].emergencyId;
        //   }
        //   if (emergencyId != undefined && emergencyId != null) {
        //     // this.askForNote(this._formBuilder, this.notificationService, emergencyId);

        //     this.askForNotes(this._formBuilder, this.notificationService, emergencyId)
        //       .then(
        //         (dataNote) => {
        //           this.newSnackbar(`Nota chiusura creata.`, 'success');
        //           console.log('errNote: ', dataNote);

        //         },
        //         (errNote) => {
        //           this.newSnackbar(`Errore creazione nota chiusura.`, 'warn');
        //           console.log('errNote: ', errNote);
        //         }
        //       );
        //   }
        //   delete this.emergencies[toUserId];
        // }, (error) => {
        //   this.loading = false;
        //   console.error(error);
        //   delete this.emergencies[toUserId];
        // });
      }
    };
    this.closeAllEmergencyByUserId(toUserId, closed);

  }

  closeAllEmergencyByUserId(data: any, callback: any) {

    // const dialog = this.dialog.open(EliminazioneSegnalazioneComponent, {
    //   // data: `${data}`,
    //   data: {
    //     newWay: true,
    //     title: 'Chiusura emergenza',
    //     body: 'Si procede alla chiusura dell\'emergenza utente'
    //   }

    // });

    // dialog.afterClosed().subscribe((datas) => {
    //   console.log(datas);
    //   if (datas && datas['data']) {
    //     callback(datas);
    //   } else {
    //     callback(null);
    //   }
    // });

    callback({ data: true });

  }

  ngOnDestroy(): void {
    if (this.eventsSub) {
      this.eventsSub.unsubscribe();
    }
    this.isInEmergency = false;
  }

}
